import { render } from "./DataPage.vue?vue&type=template&id=35590d6e&scoped=true"
import script from "./DataPage.vue?vue&type=script&lang=js"
export * from "./DataPage.vue?vue&type=script&lang=js"

import "./DataPage.vue?vue&type=style&index=0&id=35590d6e&lang=less&scoped=true"

import exportComponent from "/aqua/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-35590d6e"]])

export default __exports__